import { useEffect, useRef } from "react";

/**
 * Runs `load` once, the first time `when` is true.
 *
 * For data only one part of a page needs, such as a filter panel's dropdown
 * options: they used to load before the list's first paint, competing with
 * the list's own request, though most visits never open the panel.
 */
export function useLoadOnce(when: boolean, load: () => void) {
  const done = useRef(false);
  useEffect(() => {
    if (!when || done.current) return;
    done.current = true;
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- runs once, when first needed
  }, [when]);
}
